export enum IMembershipSubscriptionStatus {
  ACTIVE = "ACTIVE",
  UNKNOWN = "UNKNOWN",
  NEW = "NEW",
  EXPIRED = "EXPIRED",
  CANCELLED = "CANCELLED",
  INVALID = "INVALID"
}

export enum IMembershipSubscriptionProvider {
  APPSTORE = "APPSTORE",
  BRAINTREE = "BRAINTREE",
  GENERIC = "GENERIC",
  GOOGLE_PLAY = "GOOGLE_PLAY",
  PAYPAL = "PAYPAL",
  STRIPE = "STRIPE",
  UNKNOWN = "UNKNOWN"
}

export type IUser = {
  firstName: string;
  lastName: string;
  membershipSubscription: {
    status: IMembershipSubscriptionStatus;
    provider: IMembershipSubscriptionProvider;
  };
  pro?: {
    group: {
      id: string;
      title: string;
      subscriptionPayer: number;
    };
  };
};
